import { Component, OnInit } from '@angular/core';
import { SharedModule } from '@Shared/shared.module';
import { FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { BaseInterviewFormFieldComponent, BaseFormFieldServices } from '../base-interview-form-field/base-interview-form-field.component';
import { FieldDetailsComponent } from '@Components/field-details/field-details.component';
import { InterviewProcessingStatusComponent } from '@App/interview/components/interview-processing-status/interview-processing-status.component';

@Component({
    selector: 'email-answer',
    templateUrl: './email-answer.component.html',
    styleUrls: ['./email-answer.component.scss'],
    imports: [SharedModule, FieldDetailsComponent, InterviewProcessingStatusComponent]
})
export class EmailAnswerComponent extends BaseInterviewFormFieldComponent implements OnInit {
    constructor(public services: BaseFormFieldServices) {

        super(services);
    }

    ngOnInit() {
        super.initialize({
            inputType: 'text',
            additionalValidators: [
                Validators.email
            ]
        });
    }
}
